import React from "react";
import "../../../style/main.scss";
import event from "../../../assets/images/blog/event.png";
import { useTranslation } from "react-i18next";
const Banner = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="event-banner v-center h-center flex-column">
        <div className="freebotdm-title v-center h-center flex-column">
          <h2 className="one"> {t("Events")}</h2>
          <p className="large text-black">{t("Your_guide_to_DM")}</p>
          <img src={event} alt="partner-image" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};
export default Banner;